import React from 'react';
import { Collapse } from 'antd';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/store';
import EnhancedTable from './EnhancedTable';
import { EMPTY_MESSAGES, TABLE_COLUMNS, EXPORT_TYPES } from './constants';
import type { Merchant } from './types';

const { Panel } = Collapse;

interface MerchantsSectionProps {
  isOpen: boolean;
  onExport?: () => void;
}

const MerchantsSection: React.FC<MerchantsSectionProps> = ({ isOpen, onExport }) => {
  const { merchants, loading } = useSelector((state: RootState) => state.adminReports);

  const tableData = merchants.map((m: Merchant) => ({
    'Merchant Name': m.name || m.business_name || 'N/A',
    Address: m.address || 'N/A',
    Email: m.email || 'N/A',
    Phone: m.phone || 'N/A',
    Status: m.status !== undefined ? m.status : true,
  }));

  return (
    <Collapse activeKey={isOpen ? ['merchants'] : []} ghost>
      <Panel key="merchants" header="" showArrow={false}>
        <EnhancedTable
          data={tableData}
          columns={[...TABLE_COLUMNS.MERCHANTS]}
          title={EXPORT_TYPES.MERCHANTS_OVERVIEW}
          emptyMessage={EMPTY_MESSAGES.MERCHANTS}
          onExport={onExport}
          loading={loading}
        />
      </Panel>
    </Collapse>
  );
};

export default MerchantsSection;
